class SectionCollectionMain extends HTMLElement {
  constructor() {
    super();

    this.observer = null;

    this.elements = {
      sidebar: this.querySelector("[id^='CollectionMain-Sidebar']"),
      toggleSidebarButtons: this.querySelectorAll(
        "[id^='CollectionMain-Button-ToggleSidebar']"
      ),
      productCount: this.querySelector("[id^='CollectionMain-ProductCount']"),
      content: this.querySelector("[id^='CollectionMain-Content']"),
      footer: this.querySelector("[id^='CollectionMain-Footer']"),
      facets: this.querySelector("[id^='Facets']"),
      infiniteScrollButton: this.querySelector(
        "[id^='CollectionMain-InfiniteScrollButton']"
      ),
    };

    if (this.elements.infiniteScrollButton) {
      this.setupInfiniteScroll();
    }

    if (this.elements.facets) {
      this.setupFacets();
    }

    if (this.elements.toggleSidebarButtons) {
      this.setupToggleSidebarButtons();
    }
  }

  setupToggleSidebarButtons() {
    this.elements.toggleSidebarButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.elements.sidebar.classList.toggle("is-open");
      });
    });
  }

  setupInfiniteScroll() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.triggerInfiniteScroll();
        }
      });
    });

    this.observer.observe(this.elements.infiniteScrollButton);

    this.setupInfiniteScrollButton();
  }

  setupInfiniteScrollButton() {
    this.elements.infiniteScrollButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.triggerInfiniteScroll();
    });
  }

  triggerInfiniteScroll() {
    fetch(this.elements.infiniteScrollButton.dataset.nextPageUrl)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        this.observer.unobserve(this.elements.infiniteScrollButton);
        this.elements.infiniteScrollButton.remove();

        const nextPageUrl = doc.querySelector(
          "[id^=CollectionMain-InfiniteScrollButton]"
        );
        const products = doc.querySelectorAll(
          "[id^=CollectionMain-Content] > *"
        );

        this.elements.productCount.textContent = doc.querySelector(
          "[id^=CollectionMain-ProductCount]"
        ).textContent;

        products.forEach((product) => {
          this.elements.content.appendChild(product);
        });

        if (nextPageUrl) {
          this.elements.footer.appendChild(nextPageUrl);
          this.elements.infiniteScrollButton = nextPageUrl;
          this.setupInfiniteScrollButton();
          this.observer.observe(this.elements.infiniteScrollButton);
        }
      });
  }

  setupFacets() {
    this.elements.facets.addEventListener("updateFacets", (event) => {
      window.history.pushState({}, "", event.detail.url);
      this.updateFacets(event.detail);
    });
  }

  updateFacets(data) {
    // get html
    fetch(data.url, {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
      })
      .then((data) => {
        if (data) {
          this.parseFacets(data);
        }
      });
  }

  parseFacets(data) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");

    const productCount = doc.querySelector(
      "[id^=CollectionMain-ProductCount]"
    ).textContent;

    const facetsForm = doc.querySelector("[id^=Facets-Form]");

    this.elements.productCount.textContent = productCount;

    this.elements.facets.resetForm(facetsForm);

    const content = doc.querySelector("[id^=CollectionMain-Content]");
    this.elements.content.innerHTML = content.innerHTML;

    this.resetInfinitScroll(doc);
  }

  resetInfinitScroll(doc) {
    if (this.elements.infiniteScrollButton) {
      this.observer.unobserve(this.elements.infiniteScrollButton);
      this.elements.infiniteScrollButton.remove();
    }

    const nextPageUrl = doc.querySelector(
      "[id^=CollectionMain-InfiniteScrollButton]"
    );

    if (nextPageUrl) {
      this.elements.footer.appendChild(nextPageUrl);
      this.elements.infiniteScrollButton = nextPageUrl;
      this.setupInfiniteScrollButton();
      if (this.observer) {
        this.observer.observe(this.elements.infiniteScrollButton);
      } else {
        this.setupInfiniteScroll();
      }
    }
  }
}

if (window.customElements.get("section-collection-main") === undefined) {
  window.customElements.define(
    "section-collection-main",
    SectionCollectionMain
  );
}
